module.exports = __webpack_public_path__ + "static/img/sysShow2.cba5fb0f.png";